module.exports = __webpack_public_path__ + "img/south_ossetia.c3ec0d7.webp";